import { Button, Card, CardActions, CardContent, FormControl, Grid, InputLabel, MenuItem, Popper, Select, TextField, Typography } from '@mui/material';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const EntitySlotFilter = ({ isOpen, applyNewExpr, cancel, anchor, fieldToFieldDef }) => {

  const module = useModuleFromRoute();
  const rsrc = useRsrc();
  
  // Expression Types are provided by the back end
  const [exprTypes, setExprTypes] = useState();
  useEffect(() => {
    rsrc.data(module, 'EXPR_TYPES_DATA_PLUGIN', {}).then(res => {
      setExprTypes(res);
    });
  }, []);

  
  // Array of objects { field, exprType, value }
  const [filters, setFilters] = useState([]);
  
  const removeFilter = (removalIndex) => {
    setFilters(filters => filters.filter((_, index) => index !== removalIndex))
  }

  const addFilter = () => {
    setFilters([...filters, { field: '', exprType: '', value: '' }]);
  }

  const updateFilter = (changeIndex, changes) => {
    setFilters(filters => filters.map((filter, index) => index === changeIndex ? { ...filter, ...changes } : filter));
  }

  const apply = () => {

    // If nothing defined don't apply anything
    if (!filters) return applyNewExpr(null); 

    const newExpr = ExprUtils.and(...filters.map(filter => ExprUtils.fieldExpr(filter.field, filter.exprType, filter.value)));
    applyNewExpr(newExpr);
  }
  
  if (!exprTypes) return null; 
  return (
    <Popper open={isOpen} anchorEl={anchor} placement="bottom-start" sx={{ zIndex: 1200 }}>
      <Card sx={{ mt: 1, borderRadius: 4 }}>

        <CardContent>
          <Typography sx={{mb: 1, alignText: 'center'}} >Filter</Typography>

          <Grid container spacing={1} direction="column" sx={{mb: 1}}>
            {filters.map((filter, index) => (
              <Grid container item xs={12} spacing={1} key={index} alignItems="center">

                {/* Field */}
                <Grid item xs={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Field</InputLabel>
                    <Select label="Field" value={filter.field} onChange={event => updateFilter(index, { field: event.target.value })} >
                      {Object.keys(fieldToFieldDef).map(field => (
                        <MenuItem key={field} value={field}>
                          {fieldToFieldDef[field].displayName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Expression Type */}
                <Grid item xs={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Expression</InputLabel>
                    <Select label="Expression" value={filter.exprType} onChange={event => updateFilter(index, { exprType: event.target.value })} >
                      {exprTypes.map(exprType => (
                        <MenuItem key={exprType} value={exprType}>
                          {exprType}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Value */}
                <Grid item xs={4}>
                  <TextField size="small" label="Value" fullWidth value={filter.value} onChange={event => updateFilter(index, { value: event.target.value })} />
                </Grid>

                {/* Remove expr */}
                <Grid item xs={1}>
                  <Button size="small" onClick={() => removeFilter(index)}>
                    x
                  </Button>
                </Grid>
              </Grid>
            ))}
          </Grid>

          <Grid item xs={12}>
            <Button size="small" onClick={addFilter}>
              + Add rule
            </Button>
          </Grid>

        </CardContent>


        {/* Bottom Buttons */}
        <CardActions sx={{ justifyContent: 'flex-end', p: 1 }}>
          <Button size="small" onClick={cancel}>Cancel</Button>
          <Button size="small" variant="contained" onClick={apply}>Apply</Button>
        </CardActions>

      </Card>
    </Popper>
  );
};

